export const FILTER_ACTIONS = 'actions';
export const FILTER_ACTIONS_BY = 'actionsBy';
export const FILTER_PERIOD = 'period';
